export const COM_WITHOUT_BILLING_SETUP = "COMWithoutBillingSetup";
export const COM_WITHOUT_DEFAULT_PRODUCT = "COMWithoutDefaultProduct";
export const COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET = "COMWithoutDefaultProductAndHasMissingOutlet";